// src/app/component/establishment-switcher/establishment-switcher.component.ts
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EstablishmentBrief } from '../../core/session.service';

@Component({
  selector: 'app-establishment-switcher',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './establishment-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./establishment-switcher.component.scss'],
})
export class EstablishmentSwitcherComponent {
  @Input() establishments: EstablishmentBrief[] = [];
  @Input() selectedId: string | null = null;

  /** Émet uniquement l'id sélectionné (simple et robuste) */
  @Output() changed = new EventEmitter<string>();

  get sortedEstablishments(): EstablishmentBrief[] {
    const sorted = [...this.establishments].sort((a, b) => a.name.localeCompare(b.name));
    if (!this.selectedId) return sorted;

    const selectedIndex = sorted.findIndex(e => e.id === this.selectedId);
    if (selectedIndex === -1) return sorted;

    const selected = sorted.splice(selectedIndex, 1)[0];
    return [selected, ...sorted];
  }

  onNativeChange(value: string): void {
    if (value) this.changed.emit(value);
  }

  trackById = (_: number, e: EstablishmentBrief) => e.id;
}
